/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
RCA.client.Channels = (function () {
    'use strict';
    /* ----- Declare Variables ---------------------------------------------------------------------------------------- */
    var $templateChannelItem;

    /* ----- Init Channels -------------------------------------------------------------------------------------------- */
    function Init() {
        $templateChannelItem = $('template#tplChannelItem').remove().contents();
        Build();

        if ('currentChannel' in RCA.shared.localState && RCA.shared.localState.currentChannel != undefined && RCA.shared.localState.currentChannel != "undefined") {
            localStorage.setItem('rca4_current_channel', RCA.shared.localState.currentChannel);
        }
        RCA.shared.localState.currentChannel = localStorage.getItem('rca4_current_channel') || ['ch0'];
        $('#channelList [data-channel=' + RCA.shared.localState.currentChannel + ']').trigger('click');
        delete RCA.client.Channels.Init;
    }

    /* ----- Change Channels ------------------------------------------------------------------------------------------ */
    function update() {
        $.post('api/', {
            do: 'getChannels'
        }, function (data) {
            RCA.shared.AppData.channels = data;
            Build(); // bungi
            data = null;
        })
    }

    function sort() {
        RCA.shared.AppData.channels.sort(function (a, b) {
            return parseInt(a.sort_id) - parseInt(b.sort_id);
        });
    }

    /* ----- Build Channels ------------------------------------------------------------------------------------------- */
    function Build() {
        sort();
        var $fragmentChannels = $(document.createDocumentFragment()); // bungi
        $.each(RCA.shared.AppData.channels, function (i, el) {
            if (el.active && el.name) {
                var $clone = $templateChannelItem.clone();
                $clone.find('.data-id').text(el.channel);
                $clone.find('.data-name').text(el.name[RCA.shared.localState.lang]);
                $clone.attr('data-channel', el.channel);
                if (RCA.shared.localState.currentChannel === el.channel) {
                    $clone.addClass('color-primary');
                }
                $clone.appendTo($fragmentChannels);
            }
        });
        $('#channels #channelList').html($fragmentChannels);

        RCA.client.Issues.Build();
    }

    /* ----- Bind Events ---------------------------------------------------------------------------------------------- */
    $(document).on('click', '#channelList .item', function (e) {
        var $this = $(this);
        RCA.shared.localState.currentChannel = $this.data('channel');
        if (RCA.shared.localState.currentChannel in (RCA.shared.AppData.presentations || [])) {
            RCA.client.Presentation.source(RCA.shared.AppData.presentations[RCA.shared.localState.currentChannel]);
            RCA.client.SpeakerPresentation.source(RCA.shared.AppData.presentations[RCA.shared.localState.currentChannel]);
            if (RCA.shared.AppData.modulsettings.presentation_showtospeaker) {
                RCA.client.SpeakerPresentation.show();
            }
        } else {
            RCA.client.Presentation.source('');
            RCA.client.SpeakerPresentation.source('');
        }
        if (e.originalEvent) {
            localStorage.setItem('rca4_current_channel', $this.data('channel'));
            RCA.shared.Socket.Send('Channels.advertise', RCA.shared.localState.currentChannel);
        }
        $this.addClass('color-primary').siblings().removeClass('color-primary');
        $('#channels').find('.close-main').removeClass('disabled');
    });
    //  $( document ).on( 'socketOnline', function () {
    //    if ( localState.currentChannel ) {
    //      Socket.Send( 'Channels.advertise', localState.currentChannel );
    //    }
    //  } );
    function setChannel(data) {
        RCA.shared.localState.currentChannel = data;
        localStorage.setItem('rca4_current_channel', data);
        RCA.shared.Socket.Send('Channels.advertise', data);
        Build(); // bungi
    }

    /* ----- Public API ----------------------------------------------------------------------------------------------- */
    return {
        Init: Init,
        update: update,
        setChannel: setChannel
    };
})();
